import { useId, useState } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { DmResolvedNotification } from '../../../../services/dmNotifications';
import { CountTabLabel } from '../../../work-queue/tasks/CountTabLabel';
import { CollapsibleCell } from '../../shared/CollapsibleCell';
import { ResolvedNotificationLine } from './ResolvedNotificationLine';

const SECTION_LABEL = 'Resolved in the last 24 hours';

interface RecentlyResolvedSectionProps {
    notifications: readonly DmResolvedNotification[];
}

export function RecentlyResolvedSection({ notifications }: RecentlyResolvedSectionProps) {
    const [expanded, setExpanded] = useState(false);
    const contentId = useId();
    if (notifications.length === 0) return null;

    return (
        <section className="border-t border-gray-100">
            <h3>
                <button
                    type="button"
                    aria-expanded={expanded}
                    aria-controls={contentId}
                    onClick={() => setExpanded((open) => !open)}
                    className="flex w-full items-center gap-2 px-5 py-3 text-left text-[12.5px] font-medium text-gray-600 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-400"
                >
                    <ChevronRightIcon
                        aria-hidden="true"
                        className={`h-4 w-4 flex-shrink-0 text-gray-400 transition-transform motion-reduce:transition-none ${expanded ? 'rotate-90' : ''}`}
                    />
                    <CountTabLabel label={SECTION_LABEL} count={notifications.length} />
                </button>
            </h3>
            <div id={contentId} aria-hidden={!expanded}>
                <CollapsibleCell collapsed={!expanded}>
                    <ul className="flex flex-col gap-3 px-5 pb-4 pt-1">
                        {notifications.map((notification) => (
                            <li key={notification.id}>
                                <ResolvedNotificationLine notification={notification} />
                            </li>
                        ))}
                    </ul>
                </CollapsibleCell>
            </div>
        </section>
    );
}
